export const parseCustomProps = (raw) => {
  if (!raw) return {};
  try {
    return (typeof raw === 'string' ? JSON.parse(raw) : raw) || {};
  } catch (e) {
    console.error('Error parsing customProps:', e);
    return {};
  }
};
